import { Messages } from '../../codegen/Localize';
import { IMetricInfo } from '../models/IMetricInfo';
import { Metrics } from '../resources/Metrics';
import { ToasterService, ToastType } from '../../ts/services/ToasterService';

export namespace ResumeMetricAction {
  export async function resumeMetric(metric: IMetricInfo) {
    const viewId = metric.connectedView && metric.connectedView.viewId;
    if (!viewId) {
      throw new Error(Messages.metricResumeErrorMessage());
    }

    const result = await Metrics.resumeMetrics([metric.id]);
    if (!result.errors) {
      ToasterService.instance.pop({
        type: ToastType.Success,
        text: Messages.metricResumeSuccess({ METRIC_NAME: metric.name, }),
        testId: 'resume-metric-success'
      });
    } else {
      throw new Error(Messages.metricResumeErrorMessage());
    }
  }
}
